import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import dayjs from 'dayjs';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { addBatch, getBatch } from 'src/api/batches';
import BatchForm from 'src/components/batches/BatchForm';
import { commonReducerAction } from 'src/redux/reducers/common';
import { batchesReducerAction } from 'src/redux/reducers/batches';

const AddBatchModal = ({ handleCloseModal }) => {
  const date = dayjs().format('YYYY-MM-DD');
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { logoutUser } = commonReducerAction;
  const { updateBatches } = batchesReducerAction;
  const { user ,gymId} = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          padding: '.8rem',
          backgroundColor: 'background.default',
          borderRadius: '10px'
        }}
      >
        <Formik
          initialValues={{
            name: '',
            start_time: null,
            end_time: null
          }}
          validationSchema={CONSTANTS.batchValidationSchema}
          onSubmit={async (values) => {
            values.start_time = dayjs(date + values.start_time).valueOf();
            values.end_time = dayjs(date + values.end_time).valueOf();
            values.gym_id = gymId;
            try {
              dispatch(startLoading());
              const res = await addBatch(user, values);
              dispatch(stopLoading());
              const isError = res.status !== 200;
              const message = isError ? res?.message : "Batch Added Successfully"
              setSnackbarState({
                open: true,
                message: message,
                severity: isError ? 'error' : 'success'
              });
              if (!isError) {
                getBatch(user ,gymId)
                  .then((res) => {
                    if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
                      dispatch(logoutUser())
                    if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
                      dispatch(updateBatches(res.data));
                    }
                    dispatch(stopLoading());
                    handleCloseModal();
                  })
                  .catch((err) => {
                    dispatch(stopLoading());
                    console.log(err);
                  });
              }
            } catch (err) {
              dispatch(stopLoading());
              setSnackbarState({
                open: true,
                message: err.message,
                severity: 'error'
              });
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values
          }) => (
            <BatchForm
              errors={errors}
              handleBlur={handleBlur}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              touched={touched}
              values={values}
              handleCloseModal={handleCloseModal}
              heading={STRINGS.ADD_BATCH}
            />
          )}
        </Formik>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarState.open}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <div>
            <Alert onClose={handleClose} severity={snackbarState.severity}>
              {snackbarState.message}
            </Alert>
          </div>
        </Snackbar>
      </Container>
    </>
  );
};

export default AddBatchModal;
